import React, { useRef, useState } from "react";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import PopUp from "../containers/PopUp";
import Detailes from "../routs/card/cardDeailes";

const MyCropperComp = ({
  save,
  cancel,
  src,
  srcPrev,
  setSrcPrev,
  cropped,
  setCropped,
  element,
}) => {
  const cropperRef = useRef(null);

  const [isDefault, setIsDefault] = useState(false);

  const _cropChange = () => {
    if (cropped) setCropped(false);
  };

  const _crop = () => {
    const cropperInstance = cropperRef.current?.cropper;
    if (!cropperInstance) return;

    const croppedCanvas = cropperInstance.getCroppedCanvas();
    if (!croppedCanvas) return;

    const croppedSrc = croppedCanvas.toDataURL("image/jpeg");
    setSrcPrev(croppedSrc);
    setCropped(true);
  };

  const onSave = (e) => {
    e?.preventDefault();
    save(e, { isDefault });
  };

  if (!src) return null;

  return (
    <PopUp width="900px">
      <div className="flex-container" style={{ marginRight: "50px" }}>
        <div className="col-lg-6 for-crop">
          <Cropper
            src={src}
            style={{ height: 400, width: "100%" }}
            guides={true}
            checkCrossOrigin={true}
            ref={cropperRef}
            crop={_cropChange}
            zoomable={true}
            background={false}
            viewMode={1}
            responsive={true}
          />
        </div>

        <div className="col-lg-3.4" style={{ marginRight: "100px" }}>
          <div className="item-card role cropped">
            <Detailes
              inCart={false}
              productPopUp={() => {}}
              element={element}
              srcPrev={srcPrev}
            />
          </div>

          <div style={{ marginTop: "15px" }}>
            <label style={{ cursor: "pointer" }}>
              <input
                type="checkbox"
                checked={isDefault}
                onChange={(e) => setIsDefault(e.target.checked)}
                style={{ marginLeft: "8px" }}
              />
              הגדר כתמונה ראשית
            </label>
          </div>
        </div>
      </div>

      <ul className="actions">
        <li>
          {!cropped && (
            <button onClick={_crop} type="button" className="button-green">
              גזור
            </button>
          )}
          {cropped && (
            <button onClick={onSave} type="button" className="button-green">
              שמור
            </button>
          )}
          <button onClick={cancel} type="button" className="button-red">
            ביטול
          </button>
        </li>
      </ul>
    </PopUp>
  );
};

export default MyCropperComp;
